export function setItemInStorage(key, value) {
  localStorage.setItem(key, value);
}

export function getItemInStorage(key) {
  return localStorage.getItem(key);
}

export function removeItemInStorage(key) {
  localStorage.removeItem(key);
}
